import http from '../../Common/api';
import { payerDomain } from '../../Common/constants';

import { aggregatorsUrl, payersUrl, dropDownDefault } from './constants';
import { normalizeAggregators, normalizePayers, normalizeReasons } from './normalizers';

const getAggregatorOptions = async () => {
  try {
    const aggregators = await http.get(aggregatorsUrl);

    return normalizeAggregators(aggregators);
  } catch (error) {
    return dropDownDefault;
  }
};

const getPayerOptions = async aggregatorID => {
  try {
    const payers = await http.get(`${payersUrl}${aggregatorID}/`);

    return normalizePayers(payers);
  } catch (error) {
    return [];
  }
};

const getReasonReports = async ({ aggregatorID, payerID }) => {
  try {
    const state = aggregatorID.slice(0, 2);
    const reasonsUrl = `${payerDomain}/reason-codes-for-payer/${state}/${payerID}/`;
    const response = await http.get(reasonsUrl);

    return { reasonCodes: normalizeReasons(response.reasonCodes), status: '' };
  } catch (error) {
    return { reasonCodes: [], status: error.status };
  }
};

export { getAggregatorOptions, getPayerOptions, getReasonReports };
